import React, { useState, useEffect } from 'react';
import { MAINTENANCE_CONFIG } from '../config/maintenance';
import '../styles/MaintenanceMode.css';

const MaintenanceMode: React.FC = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const difference = MAINTENANCE_CONFIG.targetDate - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
        });
      }
    };

    const timer = setInterval(calculateTimeLeft, 1000);
    calculateTimeLeft(); // Initial call

    return () => clearInterval(timer);
  }, []);

  const TimerUnit: React.FC<{ value: number; label: string }> = ({ value, label }) => (
    <div className="timer-unit">
      <div className="timer-value">
        {value.toString().padStart(2, '0')}
      </div>
      <div className="timer-label">{label}</div>
    </div>
  );

  return (
    <div className="maintenance-container">
      <div className="mesh-gradient"></div>
      
      <div className="maintenance-content">
        <div className="glass-card">
          <div className="logo-placeholder">
            <svg width="60" height="60" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M50 10L90 30V70L50 90L10 70V30L50 10Z" stroke="url(#logo-gradient)" strokeWidth="4" />
              <defs>
                <linearGradient id="logo-gradient" x1="10" y1="10" x2="90" y2="90" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#6366f1" />
                  <stop offset="1" stopColor="#a855f7" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          
          <h1 className="maintenance-title">Under Maintenance</h1>
          <p className="maintenance-message">
            {MAINTENANCE_CONFIG.message}
          </p>

          <div className="countdown-container">
            <TimerUnit value={timeLeft.days} label="Days" />
            <TimerUnit value={timeLeft.hours} label="Hours" />
            <TimerUnit value={timeLeft.minutes} label="Minutes" />
            <TimerUnit value={timeLeft.seconds} label="Seconds" />
          </div>

          <div className="contact-section">
            <p>Need urgent assistance?</p>
            <a 
              href={`mailto:${MAINTENANCE_CONFIG.supportEmail}`} 
              className="email-link"
            >
              {MAINTENANCE_CONFIG.supportEmail}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceMode;
